/**
 * Constructs a complete URL for an image by combining the CDN base URL with the provided image path
 *
 * @param {string} imagePath - The relative path of the image on the CDN
 * @returns {string} The complete URL to access the image
 */
export const getImageUrl = (imagePath: string) => {
  // Combine the CDN base URL from environment variables with the provided image path
  return process.env.NEXT_PUBLIC_WEARABLES_CDN + imagePath;
};
